/**
 * Living Roots – Product Card JS (Fast)
 * assets/product-card-fast.js
 * 
 * Handles:
 * - Variant selection (price updates, selected state)
 * - Add to cart with cart drawer integration
 * 
 * Works on: Collection pages, search results, any page using product-card-fast.liquid
 */

document.addEventListener('DOMContentLoaded', function() {
  initProductCards();
});

function initProductCards() {
  const cards = document.querySelectorAll('[data-lr-carousel-card]');
  
  cards.forEach((card) => {
    // Card click - navigate to product (except variants and add to cart)
    card.addEventListener('click', (e) => {
      if (e.target.closest('.lr-card__media') || 
          e.target.closest('.lr-variant-option') || 
          e.target.closest('[data-lr-add-to-cart]')) {
        return;
      }
      
      const url = card.dataset.productUrl;
      if (url) {
        window.location.href = url;
      }
    });

    // Variant selection
    const variantOptions = card.querySelectorAll('.lr-variant-option');
    const priceEl = card.querySelector('[data-lr-current-price]');
    const comparePriceEl = card.querySelector('[data-lr-compare-price]');
    const addBtn = card.querySelector('[data-lr-add-to-cart]');

    variantOptions.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Don't select soldout variants
        if (option.hasAttribute('data-soldout')) return;

        // Update selected state
        variantOptions.forEach(opt => opt.classList.remove('lr-variant-option--selected'));
        option.classList.add('lr-variant-option--selected');

        // Update price
        const price = parseInt(option.dataset.variantPrice, 10);
        const comparePrice = option.dataset.variantComparePrice;

        if (priceEl) {
          priceEl.textContent = formatMoney(price);
        }

        if (comparePriceEl) {
          if (comparePrice && parseInt(comparePrice, 10) > price) {
            comparePriceEl.textContent = formatMoney(parseInt(comparePrice, 10));
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        // Update add to cart button
        if (addBtn) {
          addBtn.dataset.variantId = option.dataset.variantId;
        }
      });
    });

    // Add to cart
    if (addBtn) {
      addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const id = addBtn.getAttribute('data-variant-id');
        if (!id) return;

        addBtn.innerHTML = '<span class="lr-btn-spinner"></span>';
        addBtn.disabled = true;

        window.LRCart.add([{ id: Number(id), quantity: 1 }], () => {
          addBtn.textContent = 'Add to Cart';
          addBtn.disabled = false;
        });
      });
    }
  });
}

// Format money (Shopify stores prices in cents)
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}